import { AiOutlineClose } from "react-icons/ai";
import { IModalProps } from "../../@interfaces";
import { Content, Header, ModalContainer, Overlay } from "./style";

const ModalBase: React.FC<IModalProps> = ({ closeModal, children, width }) => {
  return (
    <Overlay>
      <ModalContainer width={width}>
        <Header>
          <AiOutlineClose onClick={closeModal} />
        </Header>
        <Content>
          {children}
        </Content>
      </ModalContainer>
    </Overlay>
  )
}

export default ModalBase;